export const userState = {
    USER_SIGNED_IN: 'USER_SIGNED_IN',
    USER_SIGNED_OUT: 'USER_SIGNED_OUT',
};
